import * as React from 'react';
import { useMediaQuery } from '@material-ui/core';
import {
  ShowButton,
  List,
  Datagrid,
  TextField,
  EditButton,
  SimpleList,
} from 'react-admin';

export const CouponList = (props) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <List title="All coupons" {...props}>
      {isSmall ? (
        <SimpleList
          primaryText={(record) => record.id}
          secondaryText={(record) => record.code}
          tertiaryText={(record) => record.expiredAt}
        />
      ) : (
        <Datagrid>
          <TextField source="name" label="Name/Description" />
          <TextField source="code" />
          <TextField source="startAt" />
          <TextField source="expiredAt" />
          <TextField source="maxTimes" />
          <TextField source="usedTimes" />
          <EditButton />
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
